import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch"

const deleteProjectProductAssignment = (
    backend: string,
    token: string,
    id: number
) => {
    return fetch(
        `${getApiUrl(backend)}product_assignments/${id}`,
        {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
        }
    );
};

export default deleteProjectProductAssignment;
